// extracted by mini-css-extract-plugin
export default {"profilePanel":"ProfilePanel_profilePanel__u-cvv","hide":"ProfilePanel_hide__XhjLn","alignLeft":"ProfilePanel_alignLeft__nUfav","profileMenu":"ProfilePanel_profileMenu__cgKyZ"};